import { Environment, MockDataConfig } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://applicationbackend-124917071187.us-east4.run.app/api',
  mockUrl: '../../mock/',
  commandCenterUrl: 'https://dev-commandcenter.transend.io',
  showPopulateButtons: true,
  mockData: {
    personalDetails: "personal-details.mock.json",
    aboutBusiness: "about-business.mock.json",
    businessStructure: "business-structure.mock.json",
    businessLocation: "business-location.mock.json",
    additionalOwners: "additional-owners.mock.json",
    additionalOwnerAddress: "additional-owner-address.mock.json",
    thankYouOwner: "thank-you-owner.mock.json"
  } as MockDataConfig
};
